import { createContext } from 'preact';
import { concatWebPaths, createPeerWebPath, WEB_PATH_CURRENT_DIR, WEB_PATH_SEP } from '../util/web-path.js';

// Must be JSON
export interface PageInfoProps {
  pageAbsWebPath: string;
  assetsAbsWebPath: string;
  sitePathPrefix: string;
}

export class PageInfo {
  pageAbsWebPath;
  assetsAbsWebPath;
  sitePathPrefix;

  static create(props: PageInfoProps) {
    return new PageInfo(props);
  }
  static fromJson(json: PageInfoProps) {
    return new PageInfo(json);
  }
  private constructor(props: PageInfoProps) {
    this.pageAbsWebPath = props.pageAbsWebPath;
    this.assetsAbsWebPath = props.assetsAbsWebPath;
    this.sitePathPrefix = props.sitePathPrefix;
  }

  toJson(): PageInfoProps {
    return {
      pageAbsWebPath: this.pageAbsWebPath,
      assetsAbsWebPath: this.assetsAbsWebPath,
      sitePathPrefix: this.sitePathPrefix,
    }
  }
  createPeerWebPath(webPath: string) {
    if (webPath.startsWith(WEB_PATH_SEP)) {
      return createPeerWebPath(this.pageAbsWebPath, webPath);
    } else {
      // Relative path
      return webPath;
    }
  }
  createAssetWebPath(relToAssetsDir: string) {
    if (relToAssetsDir.startsWith(WEB_PATH_SEP)) {
      throw new Error('relToAssetsDir must not be absolute: ' + relToAssetsDir);
    }
    if (relToAssetsDir.startsWith(WEB_PATH_CURRENT_DIR)) {
      relToAssetsDir = relToAssetsDir.slice(WEB_PATH_CURRENT_DIR.length); // remove prefix
    }
    const absPath = concatWebPaths(this.assetsAbsWebPath, relToAssetsDir);
    return this.createPeerWebPath(absPath);
  }
}

export const PageInfoContext = createContext<null | PageInfo>(null);
